<template>
  <!-- Hero section implementation -->
  <div
  class="relative bg-cover bg-center"
  :style="{
    backgroundImage: `url(${require('../assets/images/Gmdddddddddddd.png')})`,
  }"
>
  <div class="absolute inset-0 bg-black bg-opacity-50"></div>
  <div
    class="relative md:px-12 sm:px-12 max-w-screen-2xl mx-auto z-10 h-[30vh] lg:h-[60vh] flex items-center justify-start text-white"
  >
    <!-- About Section -->
    <h1 class="text-4xl lg:px-2 px-4 md:text-6xl font-bold animate__animated animate__backInLeft">
      Biography
    </h1>
  </div>

  <!-- Sleek Arch SVG Curve -->
  <svg
    class="absolute bottom-0 left-0 w-full"
    viewBox="0 0 1440 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#161542"
      d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
    />
  </svg>
</div>

  <!-- About Barka Mshelia -->
   <div class="bg-main">
     <div class="md:px-12 max-w-screen-2xl mx-auto">
       <div class="flex flex-col lg:flex-row gap-10 items-start">
         <div class="lg:w-1/2 mb-8">
           <!-- <h1 class="text-lg font-bold mt-8 lg:text-start lg:px-2 px-4 text-[#ada595]">
             Biography
           </h1> -->
           <p class="text-2xl mt-2 lg:mt-28 text-white lg:px-2 px-4">
             Arc. Dr. Barka Umaru Mshelia is the visionary leader and CEO of Mshel
             Group, a conglomerate that comprises Mshel Homes Ltd, Lisa Suite,
             Mshel Constructions, Mshel Integrated Systems, and Mshel Foundation.
             He is also the CEO of Mshel Consulting Limited, where he offers
             corporate strategies to businesses to prosper in a highly competitive
             market.
           </p>
           <p class="text-2xl mt-5 text-white lg:px-2 px-4">
             His passion for learning is evident in his numerous architectural,
             leadership, entrepreneurship, and business certifications from
             reputable institutions within and outside Nigeria.
           </p>
         </div>
   
         <div class="lg:w-1/2 mt-2 lg:mt-14 mb-8 lg:px-2 px-4">
           <img
             src="../assets/images/about-barka.jpeg"
             alt="About Barka U. Mshelia"
             class="w-full h-1/4 object-cover rounded-2xl"
           />
         </div>
       </div>
       <!-- Experiences and Card section -->
       <hr class="border-b border-[#ada595]" />
       <div
         ref="stats"
         class="grid grid-cols-1 md:grid-cols-4 gap-4 mt-5 mb-5 text-[#ada595]"
       >
         <div class="mb-10">
           <h1 class="font-black text-3xl text-center">
             <span>{{ experience }}</span> +
           </h1>
           <p class="font-bold text-sm text-center mt-4">Years Experience</p>
         </div>
         <div class="mb-10">
           <h1 class="font-black text-3xl text-center">
             <span>{{ mentees }}</span> +
           </h1>
           <p class="font-bold text-sm text-center mt-4">Mentees</p>
         </div>
         <div class="mb-10">
           <h1 class="font-black text-3xl text-center">
             <span>{{ properties }}</span> +
           </h1>
           <p class="font-bold text-sm text-center mt-4">Properties</p>
         </div>
         <div class="mb-10">
           <h1 class="font-black text-3xl text-center">
             <span>{{ followers }}k</span> +
           </h1>
           <p class="font-bold text-sm text-center mt-4">Followers</p>
         </div>
       </div>
     </div>
   </div>

  <!-- Youtube video section -->
   <div class="bg-white">
     <div class="md:px-12 max-w-screen-2xl mx-auto">
       <div class="text-center">
         <div class="mt-16 flex items-center justify-center">
           <img
             src="../assets/images/BM_Blue.svg"
             alt="Barka U. Mshelia"
             class="h-8 md:h-12"
           />
         </div>
   
         <!-- Video Section -->
         <div class="flex items-center justify-center mt-10">
           <iframe
             src="https://www.youtube.com/embed/aGSSXL-_QSY"
             title="YouTube video player"
             frameborder="0"
             class="lg:w-1/2 lg:h-96 md:w-full md:h-full rounded-2xl"
             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
             allowfullscreen
           ></iframe>
         </div>
   
         <!-- Book now button -->
         <div class="mt-8 mb-12">
           <router-link
             to="/mshel-club"
             class="px-8 py-2 bg-gradient text-xl text-white font-semibold rounded-full transition-all duration-300 transform hover:scale-110 focus:outline-none"
           >
             Book now
           </router-link>
         </div>
       </div>
     </div>
   </div>

  <!-- FunFact section -->
  <funFact />

  <!-- Growth and Accomplishments section -->
  <growthAndAccomplishment />
</template>

<script>
import growthAndAccomplishment from "../components/growthAndAccomplishment.vue";
import funFact from "../components/funFact.vue";

export default {
  components: {
    growthAndAccomplishment,
    funFact,
  },
  data() {
    return {
      experience: 0,
      mentees: 0,
      properties: 0,
      followers: 0,
    };
  },
  methods: {
    animateCounters() {
      const targets = {
        experience: 10,
        mentees: 1000,
        properties: 2000,
        followers: 20,
      };

      Object.keys(targets).forEach((key) => {
        let count = 0;
        const step = Math.ceil(targets[key] / 100);
        const interval = setInterval(() => {
          count += step;
          if (count >= targets[key]) {
            this[key] = targets[key];
            clearInterval(interval);
          } else {
            this[key] = count;
          }
        }, 15); // Adjust speed here
      });
    },
  },
  mounted() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.animateCounters();
          observer.disconnect(); // Trigger animation only once
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(this.$refs.stats);
  },
};
</script>

<style scoped>
.text-sm {
  font-size: 22px !important;
}
.text-xl {
  font-size: 14px !important;
}
svg path {
  fill: #161542 !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}
</style>
